import { ACTIVITY_STATUS } from "../store/constant";

export const mapActivityStatus = (key, isObject = false) => {
  const activity = ACTIVITY_STATUS.find((a) => a.key === key);
  return isObject ? activity : activity.name;
};
